import { render, staticRenderFns } from "./OrmVehicleLocationReason.vue?vue&type=template&id=bf5b7cd2"
import script from "./OrmVehicleLocationReason.vue?vue&type=script&lang=js"
export * from "./OrmVehicleLocationReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf5b7cd2')) {
      api.createRecord('bf5b7cd2', component.options)
    } else {
      api.reload('bf5b7cd2', component.options)
    }
    module.hot.accept("./OrmVehicleLocationReason.vue?vue&type=template&id=bf5b7cd2", function () {
      api.rerender('bf5b7cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/OrmVehicleLocationReason.vue"
export default component.exports